import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { HashRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { App } from "./App";
import { AuthProvider } from "@/auth/AuthProvider";
import { AuthGuard } from "@/auth/AuthGuard";
import { makeQueryClient } from "@/lib/query";
import { i18nReady } from "@/i18n";
import { apiBase } from "@/lib/config";
import "./index.css";
import "./holy-mode.css";
import "./celestial-audio.css";

const queryClient = makeQueryClient();

/** A token is valid when the gateway accepts it on GET /v1/profile. */
const validateToken = async (token: string): Promise<boolean> => {
  const res = await fetch(`${apiBase()}/v1/profile`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.ok;
};

const root = document.getElementById("root");
if (!root) throw new Error("#root not found");

void i18nReady.then(() => {
  createRoot(root).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <AuthProvider validateToken={validateToken}>
          <AuthGuard>
            <HashRouter>
              <App />
            </HashRouter>
          </AuthGuard>
        </AuthProvider>
      </QueryClientProvider>
    </StrictMode>,
  );
});
